// import React, { useEffect, useState, useMemo } from "react";
// import { toast } from "react-toastify";
// import { FaEdit, FaTrash, FaSearch } from "react-icons/fa";
// import {
//   addMatchQuestion,
//   getMatchQuestions,
//   updateDeleteMatchQuestion,
// } from "../../services/matchQuestionService";
// import { getMatches } from "../../services/matchService";
// import { getLeagues } from "../../services/leagueService";
// import { getSectionQuestions } from "../../services/sectionQuestionsService";

// export const AddAsectionsLayerList = () => {
//   const [questions, setQuestions] = useState([]);
//   const [matches, setMatches] = useState([]);
//   const [leagues, setLeagues] = useState([]);
//   const [sectionAQuestions, setSectionAQuestions] = useState([]);

//   const [showModal, setShowModal] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [loading, setLoading] = useState(false);

//   // Filters & Dynamic Pagination State
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterLeague, setFilterLeague] = useState("");
//   const [filterMatch, setFilterMatch] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10); // Default 10

//   const [form, setForm] = useState({
//     league_id: "",
//     match_id: "",
//     question_title: "",
//     options: ["", ""],
//     status: "active",
//   });

//   /* ================= LOAD DATA ================= */
//   useEffect(() => {
//     loadData();
//   }, []);

//   const loadData = async () => {
//     setLoading(true);
//     try {
//       const [leagueRes, matchRes, secRes] = await Promise.all([
//         getLeagues(),
//         getMatches(),
//         getSectionQuestions("A"), // This fetches the templates
//       ]);

//       if (leagueRes?.status) setLeagues(leagueRes.data || []);
//       if (matchRes?.status) setMatches(matchRes.data || []);
//       if (secRes?.status) setSectionAQuestions(secRes.data || []);

//       if (matchRes?.status) {
//         const questionPromises = matchRes.data.map((m) =>
//           getMatchQuestions(m.id),
//         );
//         const questionResults = await Promise.all(questionPromises);
//         const all = questionResults.flatMap((res) =>
//           res?.status ? res.data : [],
//         );
//         setQuestions(all);
//       }
//     } catch {
//       toast.error("Failed to load data");
//     }
//     setLoading(false);
//   };

//   /* ================= FILTER & PAGINATION LOGIC ================= */
//   const filteredQuestions = useMemo(() => {
//     return questions.filter((q) => {
//       const match = matches.find((m) => String(m.id) === String(q.match_id));
//       const matchesSearch = q.question_title
//         .toLowerCase()
//         .includes(searchTerm.toLowerCase());
//       const matchesLeague =
//         !filterLeague || String(match?.league_id) === String(filterLeague);
//       const matchesMatch =
//         !filterMatch || String(q.match_id) === String(filterMatch);

//       return matchesSearch && matchesLeague && matchesMatch;
//     });
//   }, [questions, searchTerm, filterLeague, filterMatch, matches]);

//   const totalPages = Math.ceil(filteredQuestions.length / itemsPerPage);

//   const currentTableData = useMemo(() => {
//     const start = (currentPage - 1) * itemsPerPage;
//     return filteredQuestions.slice(start, start + itemsPerPage);
//   }, [filteredQuestions, currentPage, itemsPerPage]);

//   const leagueMatches = useMemo(() => {
//     if (!form.league_id) return [];
//     return matches.filter(
//       (m) => String(m.league_id) === String(form.league_id),
//     );
//   }, [form.league_id, matches]);

//   const filterLeagueMatches = useMemo(() => {
//     if (!filterLeague) return matches;
//     return matches.filter((m) => String(m.league_id) === String(filterLeague));
//   }, [filterLeague, matches]);

//   const handleMatchChange = (matchId) => {
//     const selected = matches.find((m) => String(m.id) === String(matchId));
//     if (!selected) return;
//     setForm({
//       ...form,
//       match_id: matchId,
//       options: [selected.team_a, selected.team_b],
//     });
//   };

//   /* ================= CRUD ================= */
//   const handleSave = async () => {
//     if (!form.league_id || !form.match_id || !form.question_title) {
//       toast.error("All fields required");
//       return;
//     }
//     try {
//       const payload = {
//         ...form,
//         id: editId,
//         action: editId ? "update" : undefined,
//       };
//       const res =
//         editId ?
//           await updateDeleteMatchQuestion(payload)
//         : await addMatchQuestion(form);
//       if (res?.status) {
//         toast.success(editId ? "Updated Successfully" : "Added Successfully");
//         closeModal();
//         loadData();
//       } else {
//         toast.error(res?.message || "Operation failed");
//       }
//     } catch {
//       toast.error("Server error");
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this question?")) return;
//     const res = await updateDeleteMatchQuestion({ action: "delete", id });
//     if (res?.status) {
//       toast.success("Deleted Successfully");
//       loadData();
//     }
//   };

//   const handleEdit = (q) => {
//     const match = matches.find((m) => String(m.id) === String(q.match_id));
//     setEditId(q.id);
//     setForm({
//       league_id: match?.league_id || "",
//       match_id: q.match_id,
//       question_title: q.question_title,
//       options: q.options || ["", ""],
//       status: q.status || "active",
//     });
//     setShowModal(true);
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setEditId(null);
//     setForm({
//       league_id: "",
//       match_id: "",
//       question_title: "",
//       options: ["", ""],
//       status: "active",
//     });
//   };

//   return (
//     <div className="container-fluid mt-4">
//       <div className="card shadow-sm border-0">
//         <div className="card-header bg-white d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 py-3">
//           <h5 className="fw-bold mb-0">Section A Questions List</h5>
//           <button
//             className="btn btn-primary btn-sm"
//             onClick={() => {
//               closeModal();
//               setShowModal(true);
//             }}>
//             + Add Question
//           </button>
//         </div>

//         <div className="card-body">
//           {/* FILTER & PAGE SIZE SECTION */}
//           <div className="row g-2 mb-4">
//             <div className="col-12 col-md-3">
//               <div className="input-group input-group-sm">
//                 <span className="input-group-text bg-light">
//                   <FaSearch />
//                 </span>
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Search question..."
//                   value={searchTerm}
//                   onChange={(e) => {
//                     setSearchTerm(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                 />
//               </div>
//             </div>
//             <div className="col-6 col-md-3">
//               <select
//                 className="form-select form-select-sm"
//                 value={filterLeague}
//                 onChange={(e) => {
//                   setFilterLeague(e.target.value);
//                   setFilterMatch("");
//                   setCurrentPage(1);
//                 }}>
//                 <option value="">All Leagues</option>
//                 {leagues.map((l) => (
//                   <option key={l.id} value={l.id}>
//                     {l.league_name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div className="col-6 col-md-3">
//               <select
//                 className="form-select form-select-sm"
//                 value={filterMatch}
//                 onChange={(e) => {
//                   setFilterMatch(e.target.value);
//                   setCurrentPage(1);
//                 }}>
//                 <option value="">All Matches</option>
//                 {filterLeagueMatches.map((m) => (
//                   <option key={m.id} value={m.id}>
//                     {m.team_a} vs {m.team_b}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div className="col-12 col-md-3">
//               <div className="d-flex align-items-center gap-2">
//                 <span className="small text-muted text-nowrap">Show:</span>
//                 <select
//                   className="form-select form-select-sm"
//                   value={itemsPerPage}
//                   onChange={(e) => {
//                     setItemsPerPage(Number(e.target.value));
//                     setCurrentPage(1);
//                   }}>
//                   <option value={10}>10 rows</option>
//                   <option value={50}>50 rows</option>
//                   <option value={100}>100 rows</option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           <div className="table-responsive">
//             <table className="table table-bordered align-middle">
//               <thead className="table-light">
//                 <tr>
//                   <th>#</th>
//                   <th>League</th>
//                   <th>Match</th>
//                   <th>Question</th>
//                   <th>Status</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ?
//                   <tr>
//                     <td colSpan="6" className="text-center py-4">
//                       Loading Data...
//                     </td>
//                   </tr>
//                 : currentTableData.length > 0 ?
//                   currentTableData.map((q, i) => {
//                     const match = matches.find(
//                       (m) => String(m.id) === String(q.match_id),
//                     );
//                     return (
//                       <tr key={q.id}>
//                         <td>{(currentPage - 1) * itemsPerPage + i + 1}</td>
//                         <td>{match?.league_name}</td>
//                         <td className="small">
//                           {match?.team_a} vs {match?.team_b}
//                         </td>
//                         <td>{q.question_title}</td>
//                         <td>
//                           <span
//                             className={`badge ${q.status === "active" ? "bg-success" : "bg-secondary"}`}>
//                             {q.status}
//                           </span>
//                         </td>
//                         <td>
//                           <button
//                             className="btn btn-sm btn-primary me-2"
//                             onClick={() => handleEdit(q)}>
//                             <FaEdit />
//                           </button>
//                           <button
//                             className="btn btn-sm btn-danger"
//                             onClick={() => handleDelete(q.id)}>
//                             <FaTrash />
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 : <tr>
//                     <td colSpan="6" className="text-center text-muted">
//                       No questions found.
//                     </td>
//                   </tr>
//                 }
//               </tbody>
//             </table>
//           </div>

//           {/* PAGINATION FOOTER */}
//           {totalPages > 1 && (
//             <div className="d-flex justify-content-between align-items-center mt-3">
//               <p className="small text-muted mb-0">
//                 Showing {currentTableData.length} of {filteredQuestions.length}
//               </p>
//               <nav>
//                 <ul className="pagination pagination-sm mb-0">
//                   <li
//                     className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
//                     <button
//                       className="page-link shadow-none"
//                       onClick={() => setCurrentPage(currentPage - 1)}>
//                       Prev
//                     </button>
//                   </li>
//                   {[...Array(totalPages)].map((_, idx) => (
//                     <li
//                       key={idx}
//                       className={`page-item ${currentPage === idx + 1 ? "active" : ""}`}>
//                       <button
//                         className="page-link shadow-none"
//                         onClick={() => setCurrentPage(idx + 1)}>
//                         {idx + 1}
//                       </button>
//                     </li>
//                   ))}
//                   <li
//                     className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
//                     <button
//                       className="page-link shadow-none"
//                       onClick={() => setCurrentPage(currentPage + 1)}>
//                       Next
//                     </button>
//                   </li>
//                 </ul>
//               </nav>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* MODAL */}
//       {showModal && (
//         <>
//           <div className="modal fade show d-block" tabIndex="-1">
//             <div className="modal-dialog modal-dialog-centered">
//               <div className="modal-content border-0 shadow-lg">
//                 <div className="modal-header">
//                   <h5 className="modal-title fw-bold">
//                     {editId ? "Update Question" : "Add Question"}
//                   </h5>
//                   <button
//                     className="btn-close shadow-none"
//                     onClick={closeModal}></button>
//                 </div>

//                 {/* 👇 FIX: Added scroll control */}
//                 <div
//                   className="modal-body"
//                   style={{ maxHeight: "70vh", overflowY: "auto" }}>
//                   <label className="form-label small fw-bold">
//                     Select League
//                   </label>
//                   <select
//                     className="form-select mb-2 shadow-none"
//                     value={form.league_id}
//                     onChange={(e) =>
//                       setForm({ ...form, league_id: e.target.value })
//                     }>
//                     <option value="">Choose League</option>
//                     {leagues.map((l) => (
//                       <option key={l.id} value={l.id}>
//                         {l.league_name}
//                       </option>
//                     ))}
//                   </select>

//                   <label className="form-label small fw-bold">
//                     Select Match
//                   </label>
//                   <select
//                     className="form-select mb-2 shadow-none"
//                     value={form.match_id}
//                     onChange={(e) => handleMatchChange(e.target.value)}>
//                     <option value="">Choose Match</option>
//                     {leagueMatches.map((m) => (
//                       <option key={m.id} value={m.id}>
//                         {m.team_a} vs {m.team_b}
//                       </option>
//                     ))}
//                   </select>

//                   <label className="form-label small fw-bold">
//                     Select Question Template
//                   </label>

//                   {/* 👇 FIX: Added dropdown height control */}
//                   <select
//                     className="form-select mb-3 shadow-none"
//                     style={{ maxHeight: "200px" }}
//                     value={form.question_title}
//                     onChange={(e) =>
//                       setForm({
//                         ...form,
//                         question_title: e.target.value,
//                       })
//                     }>
//                     <option value="">Choose Template</option>
//                     {sectionAQuestions.map((q) => (
//                       <option key={q.id} value={q.question}>
//                         {q.question}
//                       </option>
//                     ))}
//                   </select>

//                   <div className="row g-2">
//                     <div className="col-6">
//                       <label className="form-label small fw-bold text-muted">
//                         Option 1
//                       </label>
//                       <input
//                         className="form-control bg-light border-0"
//                         value={form.options[0] || ""}
//                         readOnly
//                       />
//                     </div>
//                     <div className="col-6">
//                       <label className="form-label small fw-bold text-muted">
//                         Option 2
//                       </label>
//                       <input
//                         className="form-control bg-light border-0"
//                         value={form.options[1] || ""}
//                         readOnly
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="modal-footer border-0">
//                   <button
//                     className="btn btn-secondary btn-sm px-3"
//                     onClick={closeModal}>
//                     Cancel
//                   </button>
//                   <button
//                     className="btn btn-success btn-sm px-4 fw-bold"
//                     onClick={handleSave}>
//                     {editId ? "Update" : "Save"}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="modal-backdrop fade show"></div>
//         </>
//       )}
//     </div>
//   );
// };

import React, { useEffect, useState, useMemo } from "react";
import { toast } from "react-toastify";
import { FaEdit, FaTrash, FaSearch } from "react-icons/fa";
import {
  addMatchQuestion,
  getMatchQuestions,
  updateDeleteMatchQuestion,
} from "../../services/matchQuestionService";
import { getMatches } from "../../services/matchService";
import { getLeagues } from "../../services/leagueService";
import { getSectionQuestions } from "../../services/sectionQuestionsService";

export const AddAsectionsLayerList = () => {
  const [questions, setQuestions] = useState([]);
  const [matches, setMatches] = useState([]);
  const [leagues, setLeagues] = useState([]);
  const [sectionAQuestions, setSectionAQuestions] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);

  // Filters & Dynamic Pagination State
  const [searchTerm, setSearchTerm] = useState("");
  const [filterLeague, setFilterLeague] = useState("");
  const [filterMatch, setFilterMatch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default 10

  const [form, setForm] = useState({
    league_id: "",
    match_id: "",
    question_title: "",
    options: ["", ""],
    status: "active",
  });

  // 1-second toast configuration
  const toastConfig = { autoClose: 1000 };

  /* ================= LOAD DATA ================= */
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const [leagueRes, matchRes, secRes] = await Promise.all([
        getLeagues(),
        getMatches(),
        getSectionQuestions("A"), // This fetches the templates
      ]);

      if (leagueRes?.status) setLeagues(leagueRes.data || []);
      if (matchRes?.status) setMatches(matchRes.data || []);
      if (secRes?.status) setSectionAQuestions(secRes.data || []);

      if (matchRes?.status) {
        const questionPromises = matchRes.data.map((m) =>
          getMatchQuestions(m.id),
        );
        const questionResults = await Promise.all(questionPromises);
        const all = questionResults.flatMap((res) =>
          res?.status ? res.data : [],
        );
        setQuestions(all);
      }
    } catch {
      toast.error("Failed to load data", toastConfig);
    }
    setLoading(false);
  };

  /* ================= FILTER & PAGINATION LOGIC ================= */
  const filteredQuestions = useMemo(() => {
    return questions.filter((q) => {
      const match = matches.find((m) => String(m.id) === String(q.match_id));
      const matchesSearch = q.question_title
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const matchesLeague =
        !filterLeague || String(match?.league_id) === String(filterLeague);
      const matchesMatch =
        !filterMatch || String(q.match_id) === String(filterMatch);

      return matchesSearch && matchesLeague && matchesMatch;
    });
  }, [questions, searchTerm, filterLeague, filterMatch, matches]);

  const totalPages = Math.ceil(filteredQuestions.length / itemsPerPage);

  const currentTableData = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return filteredQuestions.slice(start, start + itemsPerPage);
  }, [filteredQuestions, currentPage, itemsPerPage]);

  const leagueMatches = useMemo(() => {
    if (!form.league_id) return [];
    return matches.filter(
      (m) => String(m.league_id) === String(form.league_id),
    );
  }, [form.league_id, matches]);

  const filterLeagueMatches = useMemo(() => {
    if (!filterLeague) return matches;
    return matches.filter((m) => String(m.league_id) === String(filterLeague));
  }, [filterLeague, matches]);

  const handleMatchChange = (matchId) => {
    const selected = matches.find((m) => String(m.id) === String(matchId));
    if (!selected) return;
    setForm({
      ...form,
      match_id: matchId,
      options: [selected.team_a, selected.team_b],
    });
  };

  /* ================= CRUD ================= */
  const handleSave = async () => {
    if (!form.league_id || !form.match_id || !form.question_title) {
      toast.error("All fields required", toastConfig);
      return;
    }
    setLoading(true);
    try {
      const payload = {
        ...form,
        id: editId,
        action: editId ? "update" : undefined,
      };
      const res =
        editId ?
          await updateDeleteMatchQuestion(payload)
        : await addMatchQuestion(form);
      if (res?.status) {
        toast.success(editId ? "Updated Successfully" : "Added Successfully", toastConfig);
        closeModal();
        loadData();
      } else {
        toast.error(res?.message || "Operation failed", toastConfig);
      }
    } catch {
      toast.error("Server error", toastConfig);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this question?")) return;
    try {
      const res = await updateDeleteMatchQuestion({ action: "delete", id });
      if (res?.status) {
        toast.success("Deleted Successfully", toastConfig);
        loadData();
      } else {
        toast.error("Delete failed", toastConfig);
      }
    } catch {
      toast.error("Server error", toastConfig);
    }
  };

  const handleEdit = (q) => {
    const match = matches.find((m) => String(m.id) === String(q.match_id));
    setEditId(q.id);
    setForm({
      league_id: match?.league_id || "",
      match_id: q.match_id,
      question_title: q.question_title,
      options: q.options || ["", ""],
      status: q.status || "active",
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditId(null);
    setForm({
      league_id: "",
      match_id: "",
      question_title: "",
      options: ["", ""],
      status: "active",
    });
  };

  return (
    <div className="container-fluid mt-4">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 py-3">
          <h5 className="fw-bold mb-0">Section A Questions List</h5>
          <button
            className="btn btn-primary btn-sm"
            onClick={() => {
              closeModal();
              setShowModal(true);
            }}>
            + Add Question
          </button>
        </div>

        <div className="card-body">
          {/* FILTER & PAGE SIZE SECTION */}
          <div className="row g-2 mb-4">
            <div className="col-12 col-md-3">
              <div className="input-group input-group-sm">
                <span className="input-group-text bg-light">
                  <FaSearch />
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search question..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>
            </div>
            <div className="col-6 col-md-3">
              <select
                className="form-select form-select-sm"
                value={filterLeague}
                onChange={(e) => {
                  setFilterLeague(e.target.value);
                  setFilterMatch("");
                  setCurrentPage(1);
                }}>
                <option value="">All Leagues</option>
                {leagues.map((l) => (
                  <option key={l.id} value={l.id}>
                    {l.league_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-6 col-md-3">
              <select
                className="form-select form-select-sm"
                value={filterMatch}
                onChange={(e) => {
                  setFilterMatch(e.target.value);
                  setCurrentPage(1);
                }}>
                <option value="">All Matches</option>
                {filterLeagueMatches.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.team_a} vs {m.team_b}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-3">
              <div className="d-flex align-items-center gap-2">
                <span className="small text-muted text-nowrap">Show:</span>
                <select
                  className="form-select form-select-sm"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}>
                  <option value={10}>10 rows</option>
                  <option value={50}>50 rows</option>
                  <option value={100}>100 rows</option>
                </select>
              </div>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>League</th>
                  <th>Match</th>
                  <th>Question</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ?
                  <tr>
                    <td colSpan="6" className="text-center py-4">
                      Loading Data...
                    </td>
                  </tr>
                : currentTableData.length > 0 ?
                  currentTableData.map((q, i) => {
                    const match = matches.find(
                      (m) => String(m.id) === String(q.match_id),
                    );
                    return (
                      <tr key={q.id}>
                        <td>{(currentPage - 1) * itemsPerPage + i + 1}</td>
                        <td>{match?.league_name}</td>
                        <td className="small">
                          {match?.team_a} vs {match?.team_b}
                        </td>
                        <td>{q.question_title}</td>
                        <td>
                          <span
                            className={`badge ${q.status === "active" ? "bg-success" : "bg-secondary"}`}>
                            {q.status}
                          </span>
                        </td>
                        <td>
                          <button
                            className="btn btn-sm btn-primary me-2"
                            onClick={() => handleEdit(q)}>
                            <FaEdit />
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDelete(q.id)}>
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    );
                  })
                : <tr>
                    <td colSpan="6" className="text-center text-muted">
                      No questions found.
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          {/* PAGINATION FOOTER */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-3">
              <p className="small text-muted mb-0">
                Showing {currentTableData.length} of {filteredQuestions.length}
              </p>
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li
                    className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link shadow-none"
                      onClick={() => setCurrentPage(currentPage - 1)}>
                      Prev
                    </button>
                  </li>
                  {[...Array(totalPages)].map((_, idx) => (
                    <li
                      key={idx}
                      className={`page-item ${currentPage === idx + 1 ? "active" : ""}`}>
                      <button
                        className="page-link shadow-none"
                        onClick={() => setCurrentPage(idx + 1)}>
                        {idx + 1}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button
                      className="page-link shadow-none"
                      onClick={() => setCurrentPage(currentPage + 1)}>
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </div>

      {/* MODAL */}
      {showModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content border-0 shadow-lg">
                <div className="modal-header">
                  <h5 className="modal-title fw-bold">
                    {editId ? "Update Question" : "Add Question"}
                  </h5>
                  <button
                    className="btn-close shadow-none"
                    onClick={closeModal}></button>
                </div>

                {/* 👇 FIX: Added scroll control */}
                <div
                  className="modal-body"
                  style={{ maxHeight: "70vh", overflowY: "auto" }}>
                  <label className="form-label small fw-bold">
                    Select League
                  </label>
                  <select
                    className="form-select mb-2 shadow-none"
                    value={form.league_id}
                    onChange={(e) =>
                      setForm({ ...form, league_id: e.target.value })
                    }>
                    <option value="">Choose League</option>
                    {leagues.map((l) => (
                      <option key={l.id} value={l.id}>
                        {l.league_name}
                      </option>
                    ))}
                  </select>

                  <label className="form-label small fw-bold">
                    Select Match
                  </label>
                  <select
                    className="form-select mb-2 shadow-none"
                    value={form.match_id}
                    onChange={(e) => handleMatchChange(e.target.value)}>
                    <option value="">Choose Match</option>
                    {leagueMatches.map((m) => (
                      <option key={m.id} value={m.id}>
                        {m.team_a} vs {m.team_b}
                      </option>
                    ))}
                  </select>

                  <label className="form-label small fw-bold">
                    Select Question Template
                  </label>

                  {/* 👇 FIX: Added dropdown height control */}
                  <select
                    className="form-select mb-3 shadow-none"
                    style={{ maxHeight: "200px" }}
                    value={form.question_title}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        question_title: e.target.value,
                      })
                    }>
                    <option value="">Choose Template</option>
                    {sectionAQuestions.map((q) => (
                      <option key={q.id} value={q.question}>
                        {q.question}
                      </option>
                    ))}
                  </select>

                  <div className="row g-2">
                    <div className="col-6">
                      <label className="form-label small fw-bold text-muted">
                        Option 1
                      </label>
                      <input
                        className="form-control bg-light border-0"
                        value={form.options[0] || ""}
                        readOnly
                      />
                    </div>
                    <div className="col-6">
                      <label className="form-label small fw-bold text-muted">
                        Option 2
                      </label>
                      <input
                        className="form-control bg-light border-0"
                        value={form.options[1] || ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                <div className="modal-footer border-0">
                  <button
                    className="btn btn-secondary btn-sm px-3"
                    onClick={closeModal}>
                    Cancel
                  </button>
                  <button
                    className="btn btn-success btn-sm px-4 fw-bold"
                    onClick={handleSave}
                    disabled={loading}>
                    {loading ? "Processing..." : editId ? "Update" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" onClick={closeModal}></div>
        </>
      )}
    </div>
  );
};
